"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceDataCode = void 0;
var ReferenceDataCode;
(function (ReferenceDataCode) {
    ReferenceDataCode[ReferenceDataCode["AdjudicationComment"] = 1] = "AdjudicationComment";
    ReferenceDataCode[ReferenceDataCode["ArrearsProblem"] = 2] = "ArrearsProblem";
    ReferenceDataCode[ReferenceDataCode["ClaimIndicatorType"] = 3] = "ClaimIndicatorType";
    ReferenceDataCode[ReferenceDataCode["ClaimProblem"] = 4] = "ClaimProblem";
    ReferenceDataCode[ReferenceDataCode["PropertyAddressProvince"] = 5] = "PropertyAddressProvince";
    ReferenceDataCode[ReferenceDataCode["PropertyAddressStreetDirection"] = 6] = "PropertyAddressStreetDirection";
    ReferenceDataCode[ReferenceDataCode["PropertyAddressStreetType"] = 7] = "PropertyAddressStreetType";
    ReferenceDataCode[ReferenceDataCode["BorrowerChargeCode"] = 8] = "BorrowerChargeCode";
    ReferenceDataCode[ReferenceDataCode["OtherAdjustmentCode"] = 9] = "OtherAdjustmentCode";
})(ReferenceDataCode = exports.ReferenceDataCode || (exports.ReferenceDataCode = {}));
